export interface IEnkInputProps {
  id?: string
  type: string
  placeholder?: string
  value?: string
  autoComplete?: string
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  required?: boolean
}

export function EnkInput(props: IEnkInputProps) {
  const { id, type, placeholder, value, autoComplete, onChange, required } = props
  return (
    <div className="mt-2">
      <input
        key={id}
        id={id}
        name={id}
        type={type}
        autoComplete={autoComplete}
        placeholder={placeholder}
        required={required}
        value={value}
        onChange={onChange}
        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
      />
    </div>
  )
}
